import React, { Component } from 'react';
import APReferralStepContainer from './../../components/organisms/APReferralStepContainer';

import { WithStyles, withStyles } from '@mui/styles';
import { withTranslate, withTenant } from '../../core/TenantProvider';
import { ReducerState } from "../../redux/modules";
import { Dispatch, bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// Referral Form Container
import { REFERRAL_FORM } from './definitions/referralForm';
import ReferralFormContainerStyles from './styles/ReferralFormContainer.style';
import withFlags from '../../core/FlagsProvider';
import { LDFlagSet } from 'launchdarkly-react-client-sdk';

interface ReferralFormContainerProps extends WithStyles<typeof ReferralFormContainerStyles> {
    translate: Function,
    flags?: LDFlagSet;
    callForTesting?: boolean;
}

interface ReferralFormContainerState {
    data: any
}

class ReferralFormContainer extends Component<ReferralFormContainerProps, ReferralFormContainerState> {

    myRef: any = null;

    constructor(props: any) {
        super(props)
        const data = REFERRAL_FORM()
        this.state = {
            data: data
        }

        this.myRef = React.createRef();
        this.onComplete = this.onComplete.bind(this);
    }

    onComplete() {
        this.myRef.current.scrollTop = 0;
    }

    render() {
        const {
            classes,
            callForTesting
        } = this.props;
        
        const referralForm = REFERRAL_FORM();

        return (
            <div ref={this.myRef} className={classes.referralFormContainer}>
                <div className={classes.referralFormItemContainer}>
                    <APReferralStepContainer
                        onComplete={this.onComplete}
                        steps={referralForm}
                        callForTesting={callForTesting}
                    />
                </div>
            </div>
        )
    }
}

const mapStateToProps = (store: ReducerState) => ({
    affiliateDetails: store.user.affiliateDetails
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(
    withFlags(
        withTenant(
            withTranslate(withStyles(ReferralFormContainerStyles)(
                (ReferralFormContainer))
            )
        )
    )
);